import { Component, EventEmitter, inject, Output, AfterViewInit, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormsModule, NgModel, ReactiveFormsModule } from '@angular/forms';
import { MatStepperModule } from '@angular/material/stepper';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { MatSlider, MatSliderModule } from '@angular/material/slider';
import {MatDatepicker, MatDatepickerModule} from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatDateFormats, provideNativeDateAdapter } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';

export const MONTH_YEAR_FORMATS: MatDateFormats = {
  parse: { dateInput: null }, // not used if input is readonly
  display: {
    // 👇 This is the important part for NativeDateAdapter
    dateInput: { month: 'long', year: 'numeric' },        // "August 2025"
    monthYearLabel: { month: 'short', year: 'numeric' },  // "Aug 2025"
    dateA11yLabel: { day: 'numeric', month: 'long', year: 'numeric' },
    monthYearA11yLabel: { month: 'long', year: 'numeric' },
  },
};

@Component({
  selector: 'timeline',
  standalone: true,
  imports: [
    CdkStepperModule,
    MatSliderModule,
    FormsModule,
    MatSliderModule,
    MatSlider,
    MatDatepickerModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
  ],
  templateUrl: './timeline.component.html',
  styleUrl: './timeline.component.scss',
  providers:[
    provideNativeDateAdapter(),
    { provide: MAT_DATE_FORMATS, useValue: MONTH_YEAR_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'en-US' },
  ]
})
export class TimelineComponent implements OnInit{
  value = 1;
  monthDays = 0;
  @Output() result: EventEmitter<Date> = new EventEmitter();

  date = new FormControl(new Date());

  ngOnInit(): void {
    const ctrlValue = new Date();
    this.value = ctrlValue.getDate();
    const dateDays = new Date(ctrlValue.getFullYear(), ctrlValue.getMonth() +1, 0);
    this.monthDays = dateDays.getDate();
    this.date.setValue(ctrlValue);
  }

  onEmitValue(){
    if(this.date.valid){
      this.result.emit(this.date.value!);
    }
  }

  onSelectTimeline(){
    const ctrlValue = this.date.value ?? new Date();
    ctrlValue.setDate(this.value);
    this.onEmitValue();
  }

  setDateFromCalendar(ctrlValue: Date, datepicker: MatDatepicker<Date>) {
  // setDateFromCalendar(normalizedMonthAndYear: Date, datepicker: MatDatepicker<Date>) {
    // const ctrlValue = this.date.value ?? new Date();
    // ctrlValue.setMonth(normalizedMonthAndYear.getMonth());
    // ctrlValue.setFullYear(normalizedMonthAndYear.getFullYear());
    // ctrlValue.setDate(1);
    this.value = ctrlValue.getDate();
    this.date.setValue(ctrlValue);
    const dateDays = new Date(ctrlValue.getFullYear(), ctrlValue.getMonth() +1, 0);
    this.monthDays = dateDays.getDate();
    // datepicker.close();
    this.onEmitValue();
  }

  setDate(date: Date){
    this.value = date.getDate();
    const dateDays = new Date(date.getFullYear(), date.getMonth() +1, 0);
    this.monthDays = dateDays.getDate();
    this.date.setValue(date);
  }

}
